import { FundDataModel } from '../../schemas/Fund.schema';
import { IInitializedParser } from './IInitializedParser';

export class FundParser implements IInitializedParser<Map<number, FundDataModel>, number | null> {
  #fundNameToFund: Map<string, FundDataModel> | undefined;

  init = (funds: Map<number, FundDataModel>) => {
    this.#fundNameToFund = [...funds.values()].reduce((map, fund: FundDataModel) => {
      map.set(fund.name.toLowerCase(), fund);
      fund.aliases?.forEach((alias) => map.set(alias.toLowerCase(), fund));
      return map;
    }, new Map<string, FundDataModel>());
    return this;
  };

  parse = (value?: string | number | null) => {
    if (typeof value === 'number') {
      return value;
    }
    return this.#fundNameToFund?.get(String(value ?? '')?.toLowerCase())?.id ?? null;
  };
}
